import { useState, useCallback } from "react";

export const useLoading = <T extends unknown[]>(
  fn: ((...args: T) => Promise<unknown> | unknown) | undefined
): [boolean, (...args: T) => Promise<void>] => {
  const [loading, setLoading] = useState(false);

  const handler = useCallback(
    async (...args: T) => {
      if (!fn) return;
      setLoading(true);
      try {
        await fn?.(...args);
      } finally {
        setLoading(false);
      }
    },
    [fn]
  );

  return [loading, handler];
};
